<template>
  <div class="radio-group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'radioGroup',
  props: {
    value: [String, Number],
    onChange: {
      type: Function,
      default() {},
    },
  },

  data() {
    return {
      checked: '',
      isRadioGroup: true,
    };
  },

  computed: {
    radioItems() {
      return this.$children;
    },
  },

  watch: {
    value() {

      this.initChecked();
    },
  },

  methods: {
    updateValue(index) {
      this.checked = '';
      this.$children.forEach((child, i) => {
        if (index !== i) {
          child.isChecked = false;
        } else {
          this.checked = child.val;
        }
      });

      this.$emit('input', this.checked);
      this.onChange(this.checked);
    },
    initChecked() {
      this.$children.forEach((child) => { 
        this.value=this.value.toString();
        if (this.value && this.value == child.val) {
          child.isChecked = true;
          child.realVal = child.val;
        } else {
          child.isChecked = false;
          child.realVal = '';
        }
      });
    },
  },

  mounted() {
    this.initChecked();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/uRadio/radioGroup.vue